import { createReducer, deleteIn, isMatchId, updateIn } from '../helpers';
import { api } from '../actions';

const setIsFetching = (state) => {
    state.isFetching = true;
};
const setIsDone = (state) => {
    state.isFetching = false;
};

const initialState = {
    collectionId: null,
    items: [],
    next: null,
    filter: {
        name: '',
        collectionId: '',
    },
    guid: 0,
    isFetching: false,
};

export default createReducer(initialState, {
    [api.products.create.request]: setIsFetching,
    [api.products.update.request]: setIsFetching,
    [api.products.delete.request]: setIsFetching,
    [api.products.sort.request]: setIsFetching,

    [api.products.sublist.failure]: setIsDone,
    [api.products.retrieve.failure]: setIsDone,
    [api.products.create.failure]: setIsDone,
    [api.products.update.failure]: setIsDone,
    [api.products.delete.failure]: setIsDone,
    [api.products.sort.failure]: setIsDone,

    [api.products.create.success]: (state, action) => {
        setIsDone(state);
        state.items.unshift(action.result);
    },
    [api.products.retrieve.success]: (state, action) => {
        setIsDone(state);
        updateIn(state.items, isMatchId(action.productId), action.result);
    },
    [api.products.update.success]: (state, action) => {
        setIsDone(state);
        updateIn(state.items, isMatchId(action.productId), action.result);
    },
    [api.products.delete.success]: (state, action) => {
        setIsDone(state);
        deleteIn(state.items, isMatchId(action.productId));
    },

    [api.products.sublist.request]: (state, action) => {
        state.isFetching = true;

        if (state.guid < (action.guid || 0) || !action.query?.next) {
            state.items = [];
        }
    },
    [api.products.sublist.success]: (state, action) => {
        if (action.guid && action.guid < state.guid) {
            return state;
        }

        state.collectionId = action.collection || null;
        state.items = action.query?.next ? state.items.concat(action.result.results) : action.result.results;
        state.next = action.result.next;
        state.isFetching = false;
    },
    [api.products.sort.success]: (state, action) => {
        state.items = action.result;
        state.isFetching = false;
    },
    [api.collections.products.update]: (state) => {
        state.guid++;
    },

    SET_PRODUCTS_SUB_FILTER: (state, action) => {
        state.filter.name = action.payload.name;
        state.filter.collectionId = action.payload.collectionId;
        state.next = null;
        state.guid = state.guid + 1;
    },

    CLEAR_PRODUCTS_SUB_STORE: () => initialState,
});
